import { ChangeEvent } from "react";

import { Profile } from "../../assets/svg";

const usernameRegex = /[^a-zA-Z0-9]/;

export const UsernameEntry = ({
    username,
    setUsername,
}: {
    username: string;
    setUsername: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const usernameChange = (e: ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        if (usernameRegex.test(val)) return;

        setUsername(val);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    borderRight: "1px solid lightgray",
                    paddingInline: "0.3em",
                    backgroundColor: "white",
                }}
            >
                <Profile size="sm" />
            </div>
            <input
                style={{
                    color: "black",
                    padding: "0.5em",
                    border: "none",
                }}
                type="text"
                placeholder="User name"
                value={username}
                onChange={(e) => usernameChange(e)}
            />
        </div>
    );
};
